import wx from '@/util/wxSdk'
import * as types from './mutations-types'

export default {
  [types.SET_USERINFO](state, data) {
    state.userInfo = data
  },
  [types.SET_SHARECONFIG](state, data) {
    state.shareConfig = data
    wx.onMenuShare(data.title, data.desc, data.link, data.imgUrl)
  },
  [types.SET_FOLLOWCONFIG](state, data) {
    state.follw = data
  },
  [types.SET_WXCONFIG](state, data) {
    state.wxConfig = data
  },
  [types.SET_VIP_CONFIG](state, data) {
    state.isOpenVipConfig = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js